import stateCitiesData from '@/data/Content/StoreLocator/storeLocatorStateCitiesList.json';
import { resolveStoreLocation } from '@/data/utils/storeLocationResolver';
import { GetServerSidePropsContext } from 'next';
import { DEFAULT_STORE_ID } from 'shared/custom/constants/commonConstants';
import { StoreData } from 'shared/custom/types/commonTypes';

export const getPhysicalStoreId = (context: GetServerSidePropsContext): string => {
	const resolvedStore = resolveStoreLocation(context);
	return resolvedStore.stLocId;
};

export const getStoreDataByPhysicalStoreId = (physicalStoreId: string | string[]) => {
	const store = stateCitiesData.formScheduleObject
		.map((stateStoreData) => stateStoreData.stores)
		.flat()
		.find((storeDataDetails) => storeDataDetails.stLocId === physicalStoreId) as StoreData;

	return store;
};

export const getDefaultStoreDataByPhysicalStoreId = () => {
	const {
		stLocId,
		storeName,
		stLocName,
		address1,
		address2,
		city,
		phone,
		latitude,
		longitude,
		zipcode,
	} = stateCitiesData.formScheduleObject
		.map((stateStoreData) => stateStoreData.stores)
		.flat()
		.find((storeDataDetails) => storeDataDetails.stLocId === DEFAULT_STORE_ID) as StoreData;

	return {
		id: stLocId,
		storeName,
		address1,
		address2,
		city,
		stLocName,
		zipcode,
		physicalStoreName: stLocName,
		storeFullAddress: `${address1}, ${address2}, ${city}`,
		phone,
		coordinates: { lat: +latitude, lng: +longitude },
		attributes: [],
	};
};
